import React from 'react';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';
import UserView from '../classroom/students/AddUsers/UserView';

export const filterStudentsByQuery = (students, query) => {
  if (!query.trim()) {
    return students;
  }

  const searchQuery = query.toLowerCase();
  return (students || []).filter(student => {
    const name = (student.name || '').toLowerCase();
    const surname = (student.surname || '').toLowerCase();
    const email = (student.email || '').toLowerCase();
    const fullName = `${name} ${surname}`.trim();
    const reversedName = `${surname} ${name}`.trim();
    return (
      name.includes(searchQuery) ||
      surname.includes(searchQuery) ||
      email.includes(searchQuery) ||
      fullName.includes(searchQuery) ||
      reversedName.includes(searchQuery)
    );
  });
};

class MultipleSelectionPanel extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    students: PropTypes.any,
    backgroundSecondary: PropTypes.any,
    currentSelection: PropTypes.any,
    backToGroups: PropTypes.any,
    selectStudent: PropTypes.any,
    drawer: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {
    title: 'rightPanel.multiple.assignTitle'
  };

  state = {
    query: ''
  };

  handleSearch = query => this.setState({ query: query || '' });

  getFilteredStudents = () => filterStudentsByQuery(this.props.students, this.state.query);

  render() {
    const { selectStudent, currentSelection, title } = this.props;

    return (
      <UserView
        title={I18n.t(title)}
        users={this.getFilteredStudents()}
        selectedUsers={currentSelection}
        showSearchArea={true}
        hasMoreItems={false}
        events={{
          onUserClick: selectStudent,
          onLoadMoreItems: () => {},
          onSearchChange: this.handleSearch
        }}
        className={{}}
      />
    );
  }
}

const mapStateToProps = state => ({
  drawer: state.drawer.content
});

export default connect(mapStateToProps)(MultipleSelectionPanel);
